export enum SessionType {
  QUOTE = 'Q',
  ORDER = 'O',
}
